import { store } from "@wordpress/interactivity";


// console.log( 'dont have a cow dude' );

const initialiseMap = ( library, map ) => {
    const lat = map.dataset.lat;
    const lng = map.dataset.lng;
    const zoom = map.dataset.zoom || 12;
		const className = map.className;

    let mapSettings = {
				disableDefaultUI: true,
        zoom: parseInt( zoom ),
				center: { lat: -34.397, lng: 150.644 },
        // mapId: "8c0e6d064542841d",
        // mapId: "DEMO_MAP_ID",
    };

    if ( lat && lng ) {
        mapSettings.center = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };
    }

    // let markers = [];

    // map.querySelectorAll( '.wp-block-abr-google-map-marker' )
    //   .forEach( markerElement => {
    //       const marker_lat = markerElement.dataset.lat;
    //       const marker_lng = markerElement.dataset.lng;
		//
		// 			const marker = {
		// 				// icon: "/wp-content/uploads/2023/07/luxe-hq.svg",
		// 				position: {
		// 					lat: parseFloat( marker_lat ),
		// 					lng: parseFloat( marker_lng ),
		// 				},
		// 			};
		//
		// 			if ( map.dataset.markerUrl ) {
		// 				marker.icon = {
		// 					url: map.dataset.markerUrl,
		// 					scaledSize: new google.maps.Size(50, 72), // scaled size
		// 					optimized: true
		// 				};
		// 			}
		//
    //       markers.push( marker );
		//
    //       // Remove from DOM
    //       markerElement.remove();
    //   } );

    // console.log( { markers } );

    const _map = new library.Map( map, mapSettings );
		const { actions, state } = store( "store-locator/directory" );

		var infowindow = new google.maps.InfoWindow({
			content: ""
		});

		actions.setMapInstance( _map );
		actions.setInfoWindowInstance( infowindow );
		actions.updateMarkersOnMap();
		actions.centreMapFromMarkers();
		actions.watchMapChanges();
};

window.initStoreLocator = () => {
	console.log('yaibb');
	// Setup places api
	const address = document.querySelector('#store-locator-address');

	const autocomplete = new google.maps.places.Autocomplete(
		address,
		{}
	);

	autocomplete.addListener( "place_changed", async function () {
		const place = await autocomplete.getPlace();

		const { state, actions } = store( "store-locator/directory" );

		state.filters.address = place.formatted_address;
		state.filters.latitude = place.geometry.location.lat();
		state.filters.longitude = place.geometry.location.lng();
	} );

	document.querySelectorAll( '.wp-block-store-locator-directory-map' )
		.forEach( mapEl => initialiseMap( window.google.maps, mapEl ) );
}
